import { commonsFr } from '@sancare/typescript-commons/src/locales'
import merge from 'lodash.merge'
import { createI18n } from 'vue-i18n'

import { codageCh, codageFr } from '@/locales'
import { CountryEnum } from '@/store/modules/settings/types'

type MessageSchema = typeof localesCh

declare global {
  interface Window {
    pmsiCountry: CountryEnum
  }
}

export enum Gender {
  Masculine = 'masculine',
  Feminine = 'feminine',
}

const i18n = createI18n<[MessageSchema], CountryEnum>({
  legacy: false,
  locale: window.pmsiCountry || 'fr',
  fallbackLocale: 'fr',
  messages: {
    ch: merge({}, commonsFr, codageFr, codageCh),
    fr: merge({}, commonsFr, codageFr),
  }
})

export default i18n
